import { faMinusCircle, faPlusCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'components/shared/Button';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { getPublicPath } from 'utils/paths';
import { INTRODATA } from './Intro.constants';
import {
  StyledContainer,
  StyledData,
  StyledDataContent,
  StyledDataItem,
  StyledDataList,
  StyledDataTitle,
  StyledDataValue,
  StyledHero,
  StyledHeroImage,
  StyledHeroTitle,
  StyledIntro,
  StyledIntroText,
  StyledIntroTitle
} from './Intro.styled';

type IntroProps = {
  manfreditesCount: number;
};

const Intro: React.FC<IntroProps> = ({ manfreditesCount }) => {
  const { t } = useI18n('developer-career-report-2024');
  const { locale } = useRouter();

  const introData = INTRODATA(t, locale, manfreditesCount);

  const [displayReadMore, setdisplayReadMore] = useState(false);

  const clampableText = useRef<HTMLDivElement>(null);

  function checkLineClamp(): void {
    if (
      clampableText.current &&
      clampableText.current.clientHeight < clampableText.current.scrollHeight
    ) {
      setdisplayReadMore(true);
    } else {
      setdisplayReadMore(false);
    }
  }

  useEffect(() => {
    checkLineClamp();
  }, []);

  const [showAllText, setShowAllText] = useState(false);

  return (
    <StyledContainer>
      <StyledHero>
        <StyledHeroImage
          src={getPublicPath('/images/stateSector/2024/hero.jpg')}
          alt=""
        />
        <StyledHeroTitle>
          <span className="pretitle">{t('mantechcar24.hero.pre-title')}</span>
          <span>
            {t('mantechcar24.hero.title')} <span className="year">2024</span>
          </span>
        </StyledHeroTitle>
      </StyledHero>
      <StyledIntro>
        <StyledIntroTitle>
          <HtmlTrans
            ns="developer-career-report-2024"
            i18nKey="mantechcar24.hero.intro-title"
          />
        </StyledIntroTitle>
        <StyledIntroText
          ref={clampableText}
          className={`${showAllText ? 'display-full-text' : ''}`}
        >
          <HtmlTrans
            ns="developer-career-report-2024"
            i18nKey="mantechcar24.hero.intro"
          />
        </StyledIntroText>
        {displayReadMore && (
          <Button
            type="button"
            onClick={(): void => setShowAllText(!showAllText)}
          >
            <FontAwesomeIcon
              icon={!showAllText ? faPlusCircle : faMinusCircle}
            />
            {!showAllText && <span>{t('mantechcar24.hero.read-more')}</span>}
            {showAllText && <span>{t('mantechcar24.hero.read-less')}</span>}
          </Button>
        )}
      </StyledIntro>

      <StyledData>
        <StyledDataTitle>{t('mantechcar24.data.title')}</StyledDataTitle>
        <StyledDataList>
          {introData.map((item, index) => (
            <StyledDataItem key={index}>
              <StyledDataValue>{item.value}</StyledDataValue>
              <StyledDataContent>{item.text}</StyledDataContent>
            </StyledDataItem>
          ))}
        </StyledDataList>
      </StyledData>
    </StyledContainer>
  );
};

export default Intro;
